import React, { Component } from "react";
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModTeam extends Component {
    render () {
	    let block 	= this.props.block;
	    let designers = block.designer.map(function(designer,i){
		    return <li className="c-designers__item" key={i}>
		    	<Link to={{ pathname: '/designer/' + designer.slug }} className="c-designers__link" dangerouslySetInnerHTML={ {__html: designer.name } }></Link>
			</li>
		});
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color + ' scope-' + block.image_effect} style={{backgroundColor: block.block_color}}>
	        	
	        	<div className="l-grid">
		        	<div className="l-grid__col">
		        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
				        	{block.heading &&
					        	<h3 className="c-designers__heading">{ block.heading }</h3>
				        	}
							<ul className="c-designers">
								{ designers }
							</ul>
						</ScrollAnimation>
					</div>
		        </div>
	        
			</div>
		)
	};

};
